<template>
  WidgetsList.vue
</template>

<script lang="js">
export default {
    name: 'WidgetsList',
}
</script>